import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import api from '../../services/api';
import Spinner from '../common/Spinner';

const AlterarSenhaObrigatoriaModal: React.FC = () => {
  const { setRequerAlteracaoSenha, setRequerSenhaGmail, usuario } = useAuth();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null);

    // Validações
    if (!novaSenha || !confirmarSenha) {
      setErro('Todos os campos são obrigatórios');
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não coincidem');
      return;
    }

    if (novaSenha.length < 6) {
      setErro('A nova senha deve ter pelo menos 6 caracteres');
      return;
    }

    try {
      setLoading(true);
      setErro(null);
      
      // Chamar a API para alterar a senha obrigatória
      const response = await api.post('/auth/alterar-senha-obrigatoria', {
        novaSenha,
        confirmarSenha
      });

      if (response.data.success) {
        toast.success('Senha alterada com sucesso!');
        
        // Fechar modal atual
        setRequerAlteracaoSenha(false);
        
        // Aguardar 300ms e abrir modal de senha do Gmail
        setTimeout(() => {
          setRequerSenhaGmail(true);
        }, 300);
      } else {
        setErro(response.data.message || 'Erro ao alterar senha');
      }
    } catch (error: any) {
      console.error('Erro ao alterar senha obrigatória:', error);
      setErro(error.response?.data?.message || 'Erro ao alterar senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <div className="mb-6 text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Alteração de Senha Obrigatória</h2>
          <p className="text-gray-600">
            Por segurança, você precisa alterar sua senha antes de continuar usando o sistema.
          </p>
        </div>

        {erro && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {erro}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="nova-senha" className="block text-sm font-medium text-gray-700 mb-1">
              Nova Senha *
            </label>
            <input
              id="nova-senha"
              type="password"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-bravo-primary focus:border-bravo-primary"
              placeholder="Digite sua nova senha (mínimo 6 caracteres)"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="mb-6">
            <label htmlFor="confirmar-senha" className="block text-sm font-medium text-gray-700 mb-1">
              Confirmar Nova Senha *
            </label>
            <input
              id="confirmar-senha"
              type="password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-bravo-primary focus:border-bravo-primary"
              placeholder="Confirme sua nova senha"
              disabled={loading}
            />
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
            <p className="text-sm text-blue-800">
              <strong>Importante:</strong> Após alterar sua senha, você poderá acessar normalmente todas as funcionalidades do sistema.
            </p>
          </div>

          <button
            type="submit"
            className="w-full px-4 py-3 bg-bravo-primary text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bravo-primary transition-colors flex items-center justify-center font-semibold"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size={18} className="!text-white mr-2" />
                Alterando Senha...
              </>
            ) : 'Alterar Senha e Continuar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AlterarSenhaObrigatoriaModal;
